export default __webpack_public_path__ + "static/media/Icon-03.e50714b2.svg";